module.exports = __webpack_public_path__ + "img/banner_index.6ff5fdfa.png";